import { render, staticRenderFns } from "./relatedOrganizations.vue?vue&type=template&id=07cb05ae"
import script from "./relatedOrganizations.vue?vue&type=script&lang=js"
export * from "./relatedOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cb05ae')) {
      api.createRecord('07cb05ae', component.options)
    } else {
      api.reload('07cb05ae', component.options)
    }
    module.hot.accept("./relatedOrganizations.vue?vue&type=template&id=07cb05ae", function () {
      api.rerender('07cb05ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/base/relatedOrganizations.vue"
export default component.exports